// extracted by mini-css-extract-plugin
module.exports = {"root":"CaptionsPanel_root__22ShM","captionListArea":"CaptionsPanel_captionListArea__3OlD0","captionList":"CaptionsPanel_captionList__Zn_aR"};